import { View } from 'react-native';

import { Anchor } from '@fhs/ui';
import { isNative } from '@fhs/utils';

interface Props {
  sections: {
    id: string;
    title: string;
    onPress: () => void;
    isActive: boolean;
    badge?: number;
  }[];
}

export function SectionsHeader({ sections }: Props) {
  return (
    <View style={{ flexDirection: 'row' }}>
      {sections.map(section => (
        <Anchor
          key={section.id}
          isActive={section.isActive}
          title={section.title}
          badge={section.badge}
          onPress={section.onPress}
          style={{ flex: 1, alignItems: 'center' }}
          titleStyle={{ textAlign: 'center', flex: 1 }}
          focusedStyle={{}}
          hoveredStyle={{}}
          titleTextProps={{
            numberOfLines: isNative ? 1 : undefined,
            adjustsFontSizeToFit: isNative ? true : undefined,
          }}
        />
      ))}
    </View>
  );
}
